export interface ExecutionDetailItem {
  label: string;
  value: string;
}

export type ParallelismMode = 'omp' | 'mpi' | 'hybrid' | 'unknown';

export interface ExecutionDetails {
  summary: ExecutionDetailItem[];
  flags: ExecutionDetailItem[];
  command: string | null;
  parallelismMode: ParallelismMode;
  rankValues: string[];
  coreValues: string[];
  inputValues: string[];
  repetitionValues: string[];
}

export const EMPTY_EXECUTION_DETAILS: ExecutionDetails = {
  summary: [],
  flags: [],
  command: null,
  parallelismMode: 'unknown',
  rankValues: [],
  coreValues: [],
  inputValues: [],
  repetitionValues: []
};
